import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.42516 17.225C7.26683 17.225 7.1085 17.1667 6.9835 17.0417C6.74183 16.8 6.74183 16.4 6.9835 16.1583L12.4168 10.725C12.8168 10.325 12.8168 9.67502 12.4168 9.27502L6.9835 3.84168C6.74183 3.60002 6.74183 3.20002 6.9835 2.95835C7.22516 2.71668 7.62516 2.71668 7.86683 2.95835L13.3002 8.39168C13.7252 8.81668 13.9668 9.39168 13.9668 10C13.9668 10.6084 13.7335 11.1834 13.3002 11.6084L7.86683 17.0417C7.74183 17.1584 7.5835 17.225 7.42516 17.225Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default ArrowRightIcon;
